// extracted by mini-css-extract-plugin
module.exports = {"container":"_8fcf41dc","placeholder":"_d42404b8"};